import { ArrowExportRegular } from "@fluentui/react-icons";
import { ActionButton, Flex } from "components/styled";
import { IRowItem } from "library/types";
import React, { useCallback } from "react";
import { ImplementBenefitDialog } from "../ImplementBenefitDialog/ImplementBenefitDialog";
import { useTranslation } from "react-i18next";
import { selectedCompanyState } from "store/UICompanyPage";
import { useAtomValue } from "jotai";

type Props = {
  item: IRowItem;
  readOnly?: boolean;
  onlyActiveImplementations?: boolean;
};
function ImplementBenefitCell({
  item,
  readOnly,
  onlyActiveImplementations,
}: Props) {
  const { t } = useTranslation();
  const selectedCompany = useAtomValue(selectedCompanyState);

  const [open, setOpen] = React.useState(false);

  const onDialogOpenChange = useCallback((state) => {
    setOpen(state);
  }, []);

  return (
    <>
      <Flex justify="flex-start" gap={"5px"}>
        <ActionButton
          disabled={readOnly}
          // disabled={!item?.selected}
          icon={<ArrowExportRegular />}
          noBorder
          appearance="subtle"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(true);
          }}
        >
          {t("hbh.implementBenefit.label")}
        </ActionButton>
      </Flex>
      {open && (
        <ImplementBenefitDialog
          onlyActiveImplementations={onlyActiveImplementations}
          isAddMode
          category={item}
          open={open}
          refetchCategoryOnAdd
          setOpen={onDialogOpenChange}
          currencyCode={selectedCompany?.currencyCodeId}
        />
      )}
    </>
  );
}

export default ImplementBenefitCell;
